import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "home",
  id: "homePage",
  style: {
    "min-width": "1560px"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "hometitle gloria-font"
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 2,
  class: "googleMaps"
};
const _hoisted_5 = {
  key: 3,
  class: "accordion"
};
const _hoisted_6 = {
  key: 4,
  class: "lowCode"
};
const _hoisted_7 = {
  key: 5,
  class: "subscription"
};
const _hoisted_8 = {
  key: 6,
  class: "richText"
};
const _hoisted_9 = {
  key: 7,
  class: "fit-up-item"
};
const _hoisted_10 = {
  key: 8,
  class: "fit-up-item"
};
const _hoisted_11 = {
  key: 9,
  class: "fit-up-item"
};
const _hoisted_12 = {
  key: 10
};
const _hoisted_13 = {
  key: 11,
  class: "fit-up-item"
};
const _hoisted_14 = {
  key: 12,
  class: "goods-list fit-up-item"
};
const _hoisted_15 = {
  key: 13,
  class: "fit-up-item"
};
const _hoisted_16 = {
  key: 14,
  class: "fit-up-item"
};
const _hoisted_17 = {
  class: "reservation",
  style: {
    "margin-bottom": "118px"
  }
};
const _hoisted_18 = {
  class: "reservation_dom"
};
const _hoisted_19 = {
  class: "target-top-box",
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin-bottom": "200px",
    "position": "relative"
  }
};
const _hoisted_20 = {
  class: "target-top",
  style: {
    "overflow": "hidden"
  }
};
const _hoisted_21 = {
  class: "target-img"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "target-img img-right"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin": "100px 0"
  }
};
const _hoisted_26 = {
  class: "event"
};
const _hoisted_27 = {
  class: "time"
};
const _hoisted_28 = {
  class: "time-box"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["id"];
const _hoisted_31 = {
  class: "title_dome_list"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  style: {
    "width": "100px"
  }
};
const _hoisted_34 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_35 = {
  class: "event_img"
};
const _hoisted_36 = ["src"];
const _hoisted_37 = {
  class: "card-box"
};
const _hoisted_38 = {
  class: "card"
};
const _hoisted_39 = {
  class: "link-content"
};
const _hoisted_40 = {
  class: "link-box"
};
const _hoisted_41 = {
  class: "link-box"
};
const _hoisted_42 = {
  class: "card"
};
const _hoisted_43 = {
  class: "link-content"
};
const _hoisted_44 = {
  class: "link-box"
};
const _hoisted_45 = {
  class: "link-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_imageText = _resolveComponent("imageText");
  const _component_googleMaps = _resolveComponent("googleMaps");
  const _component_accordion = _resolveComponent("accordion");
  const _component_mimo_replace = _resolveComponent("mimo_replace");
  const _component_lowCode = _resolveComponent("lowCode");
  const _component_subscription = _resolveComponent("subscription");
  const _component_richText = _resolveComponent("richText");
  const _component_imgSwipers = _resolveComponent("imgSwipers");
  const _component_images = _resolveComponent("images");
  const _component_videos = _resolveComponent("videos");
  const _component_goodsScroll = _resolveComponent("goodsScroll");
  const _component_navigation = _resolveComponent("navigation");
  const _component_goodsGrid = _resolveComponent("goodsGrid");
  const _component_texts = _resolveComponent("texts");
  const _component_hotMap = _resolveComponent("hotMap");
  const _component_van_image = _resolveComponent("van-image");
  const _component_popup = _resolveComponent("popup");
  const _component_about_m = _resolveComponent("about_m");
  return $setup.Client == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "assembly"
    }, [item.base.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(item.base.title), 1)])) : _createCommentVNode("", true), item.name === 'imageText' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_imageText, {
      data: item,
      imageTextIndex: index
    }, null, 8, ["data", "imageTextIndex"])])) : _createCommentVNode("", true), item.name === 'googleMaps' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_googleMaps, {
      gMaps: item
    }, null, 8, ["gMaps"])])) : _createCommentVNode("", true), item.name === 'accordion' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_accordion, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'lowCode' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [item.data === '<mimo-replace>' ? (_openBlock(), _createBlock(_component_mimo_replace, {
      key: 0
    })) : (_openBlock(), _createBlock(_component_lowCode, {
      key: 1,
      data: item
    }, null, 8, ["data"]))])) : _createCommentVNode("", true), item.name === 'subscription' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_subscription, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'richText' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_richText, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'slider' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_imgSwipers, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'images' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_images, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'video' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_videos, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'goodsScroll' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_goodsScroll, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'navigation' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_navigation, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'goodsGrid' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_goodsGrid, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_texts, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true), item.name === 'hotmap' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_hotMap, {
      data: item
    }, null, 8, ["data"])])) : _createCommentVNode("", true)]);
  }), 128)), _createElementVNode("div", _hoisted_17, [_createVNode(_component_van_image, {
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group256@2x.png"
  }), _createElementVNode("div", _hoisted_18, [_cache[8] || (_cache[8] = _createElementVNode("h1", {
    style: {
      "color": "#fff",
      "margin-bottom": "30px"
    }
  }, "立即申请预约，了解更多详细信息", -1)), _createElementVNode("div", {
    class: "reservation_btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.show && $setup.show(...args))
  }, " 点击预约 ")])]), _cache[19] || (_cache[19] = _createElementVNode("div", {
    style: {
      "text-align": "center",
      "margin": "30px 0"
    }
  }, [_createElementVNode("h1", {
    style: {
      "color": "#10A6C4",
      "margin-bottom": "10px"
    }
  }, "荣誉资质"), _createElementVNode("span", null, "严守医者仁心，用医生集团模式为患者提供服务")], -1)), _createElementVNode("div", _hoisted_19, [_cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "left_gradient"
  }, null, -1)), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "right_gradient"
  }, null, -1)), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.showPicturesList, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item
    }, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_22)]);
  }), 128))]), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.showPicturesList, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item
    }, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_24)]);
  }), 128))])])]), _cache[20] || (_cache[20] = _createElementVNode("div", {
    style: {
      "text-align": "center",
      "margin": "80px 0"
    }
  }, [_createElementVNode("h1", {
    style: {
      "color": "#10A6C4",
      "margin-bottom": "10px"
    }
  }, "米檬大事记"), _createElementVNode("span", null, "通过文字、照片、视频、以时间轴记录米檬医路成长")], -1)), $setup.event.length ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_cache[12] || (_cache[12] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/about/t_arrow.png",
    class: "arrow"
  }, null, -1)), _cache[13] || (_cache[13] = _createElementVNode("div", {
    class: "ling"
  }, null, -1)), _createElementVNode("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.event, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "time_list",
      style: _normalizeStyle('color:' + ($setup.select_year == index ? '#13A4BF;' : '#89D1DF;'))
    }, [_createElementVNode("h2", {
      onClick: $event => $setup.event_click(index, 0)
    }, _toDisplayString(item.time), 9, _hoisted_29), _cache[11] || (_cache[11] = _createElementVNode("div", {
      class: "ling"
    }, null, -1))], 4);
  }), 128))]), _cache[14] || (_cache[14] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/about/b_arrow.png",
    class: "arrow"
  }, null, -1))]), _createElementVNode("div", {
    class: "title",
    onScroll: _cache[1] || (_cache[1] = (...args) => $setup.scrolling && $setup.scrolling(...args)),
    id: "content"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.event, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "title_dome",
      key: index
    }, [_createElementVNode("h3", {
      id: 'time' + index
    }, _toDisplayString(item.time) + "(" + _toDisplayString(item.arr.length) + ")", 9, _hoisted_30), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.arr, (ite, ind) => {
      return _openBlock(), _createElementBlock("div", {
        onClick: $event => $setup.event_click(index, ind),
        key: ind,
        style: _normalizeStyle('color:' + ($setup.select_event == ind && $setup.select_year == index ? '#fff;' : ' rgba(19, 164, 191, 1);') + 'background:' + ($setup.select_event == ind && $setup.select_year == index ? '#13A4BF;' : '#DCF1F5;'))
      }, [_createElementVNode("div", _hoisted_33, [_createElementVNode("span", null, _toDisplayString(ite.time), 1)]), _createElementVNode("div", _hoisted_34, [_createElementVNode("span", null, _toDisplayString(ite.title), 1)])], 12, _hoisted_32);
    }), 128))])]);
  }), 128))], 32), _createElementVNode("div", _hoisted_35, [_createElementVNode("img", {
    src: $setup.event[$setup.select_year].arr[$setup.select_event].img_url
  }, null, 8, _hoisted_36)])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_cache[15] || (_cache[15] = _createElementVNode("div", {
    class: "title"
  }, " 患者保密、权利、责任和隐私 ", -1)), _cache[16] || (_cache[16] = _createElementVNode("div", {
    class: "content"
  }, " 米檬口腔承诺保护患者的隐私和权利 ", -1)), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("span", {
    class: "link",
    onClick: _cache[2] || (_cache[2] = $event => $setup.openFile('security'))
  }, "米檬口腔的保密性")]), _createElementVNode("div", _hoisted_41, [_createElementVNode("span", {
    class: "link",
    onClick: _cache[3] || (_cache[3] = $event => $setup.openFile('duty'))
  }, "患者权利、责任和隐私")])])]), _createElementVNode("div", _hoisted_42, [_cache[17] || (_cache[17] = _createElementVNode("div", {
    class: "title"
  }, " 公益行动 ", -1)), _cache[18] || (_cache[18] = _createElementVNode("div", {
    class: "content"
  }, " 多年来，米檬口腔经验丰富的专家团队，一直秉承公益初心，开启“爱牙公益计划”，为有机会做早期矫正的儿童提供公益服务。 ", -1)), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("span", {
    class: "link",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.gotoWelfareD && $setup.gotoWelfareD(...args)),
    style: {
      "margin-right": "202px"
    }
  }, "肌功能训练"), _createElementVNode("span", {
    class: "link",
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.gotoWelfareDB && $setup.gotoWelfareDB(...args))
  }, "爱牙日活动")]), _createElementVNode("div", _hoisted_45, [_createElementVNode("span", {
    class: "link",
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.show && $setup.show(...args)),
    style: {
      "margin-right": "220px"
    }
  }, "联系客服"), _createElementVNode("span", {
    class: "link",
    onClick: _cache[7] || (_cache[7] = (...args) => $setup.learnMore && $setup.learnMore(...args))
  }, "注册&登录")])])])]), _createVNode(_component_popup, {
    show: $setup.loginShow,
    showState: $setup.showState,
    onModifyShowState: $setup.modifyShowState,
    onGetUserData: $setup.getUserData
  }, null, 8, ["show", "showState", "onModifyShowState", "onGetUserData"])])) : (_openBlock(), _createBlock(_component_about_m, {
    key: 1
  }));
}